// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_92-0";